import { GET_USER_BUSINESS_ID } from "../../browser-db-config/localStorage";
import { HTTP_REQUEST } from "../../http-config/trac-http-req";
const actions = {
  DOWNLOAD_TEMPLATE: async function(context, payload) {
    const httpReq = {
      url: "/v1/deduction/upload/template",
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  DOWNLOAD_DEDUCTION_REPORT: async function(context, {type, date}) {
    let url = ''
    if(type === 'general') {
      url = `/v1/deduction/report/settings/csv?date=${date}`
    }
    if(type === 'loan' || type === 'saving') {
      url = `/v1/deduction/report/loan-disk?type=${type}&date=${date}`
    }
    const httpReq = {
      url,
      method: "GET",
      authRequest: true,
    };
    // console.log('url for report', url)
    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  GET_DEDUCTIONS: async function(context, payload) {
    const queryString = new URLSearchParams(payload).toString();
    const url = `/v1/deduction/settings?${queryString}`;
    console.log('querystring deductions', url)
    const httpReq = {
      url,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  TEMPLATE_VALIDATE: async function(context, payload) {
    const httpReq = {
      url: `/v1/deduction/upload/validate`,
      method: "POST",
      authRequest: true,
      body: payload,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  TEMPLATE_SUBMIT: async function(context, payload) {
    const httpReq = {
      url: `/v1/deduction/upload/save`,
      method: "POST",
      authRequest: true,
      body: payload,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  BATCH_UPDATE_DEDUCTIONS: async function(context, {status, batchOfIds}) {
    const httpReq = {
      url: `/v1/deduction/settings/toggle/${status}`,
      method: "PATCH",
      authRequest: true,
      body: batchOfIds,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  SEARCH_MERCHANT_BY_NAME: async function(context, payload) {
    const httpReq = {
      url: `/v1/businesses/nameoremail/${payload.email}`,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  FETCH_MERCHANT_DETAILS_FOR_DEDUCTION: async function(context, business_id) {
    const httpReq = {
      url: `/v1/businesses/${business_id}`,
      method: "GET",
      authRequest: true,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  ADD_DEDUCTION: async function(context, payload) {
    const httpReq = {
      url: `/v1/deduction/init`,
      method: "POST",
      authRequest: true,
      body: payload,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  ADD_DEDUCTION_BULK: async function(context, payload) {
    const httpReq = {
      url: `/v1/deduction/bulk`,
      method: "POST",
      authRequest: true,
      body: payload,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  UPDATE_DEDUCTION: async function(context, { id, payload}) {
    const httpReq = {
      url: `/v1/deduction/settings/${id}`,
      method: "PATCH",
      authRequest: true,
      body: payload,
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  DELETE_DEDUCTION: async function(context, id) {
    const httpReq = {
      url: `/v1/deduction/settings/${id}`,
      method: "DELETE",
      authRequest: true,
      body: {},
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  },
  TOGGLE_DEDUCTION_STATUS: async function(context, { id, intendedStatus }) {
    const httpReq = {
      url: `/v1/deduction/settings/toggle/${intendedStatus}?id=${id}`,
      method: "PATCH",
      authRequest: true,
      body: {},
    };

    const httpRes = await HTTP_REQUEST(httpReq);
    return httpRes;
  }
};

export default {
  actions,
};
